var render = function () {
  var _obj
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "instagram-channel-widget" },
    [
      _c(
        "md-button",
        {
          ref: "buttonRef",
          staticClass:
            "actionButtonBreadcrumb m-0 wp-btn instagram-status-button",
          class: ((_obj = {}), (_obj[_vm.getHealthStatus()] = true), _obj),
          staticStyle: { "min-width": "20px", "max-width": "25px" },
          on: {
            mouseenter: function ($event) {
              _vm.instagramIconHovered = true
            },
            mouseleave: function ($event) {
              _vm.instagramIconHovered = false
            },
            click: _vm.toggleDropdown,
          },
        },
        [
          _c("InstagramIcon", {
            staticClass: "whatsapp-channel-icon",
            attrs: {
              showGradient: _vm.instagramIconHovered || _vm.isDropdownVisible,
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _vm.isDropdownVisible
        ? _c(
            "div",
            {
              staticClass: "custom-dropdown",
              class: { "dropdown-ready": _vm.dropdownReady },
              style: _vm.dropdownStyle,
            },
            [
              _c(
                "div",
                { staticClass: "dropdown-content" },
                _vm._l(
                  _vm.filteredInstagramChannels,
                  function (channel, index) {
                    return _vm.filteredInstagramChannels.length > 0
                      ? _c("ChannelStatusItem", {
                          key: channel._id,
                          attrs: { channel: channel, "whatsapp-modal": false },
                          on: { close: _vm.closeDropdown },
                        })
                      : _vm._e()
                  }
                ),
                1
              ),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.isDropdownVisible
        ? _c("div", {
            staticClass: "dropdown-backdrop",
            on: { click: _vm.closeDropdown },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }